<template>
  <div
    ref="tablaParent"
    class="panel panel-grid-item"
    :class="`${editable ? 'bg-slate-300' : color}`"
  >
    <!-- Iconos acciones -->
    <div :class="{ 'vue-draggable-handle glyphicon glyphicon-move': editable }"></div>
    <div
      :class="{ 'vue-removable-handle glyphicon glyphicon-remove': editable }"
      @click="onClickEliminar()"
    ></div>
    <div
      v-if="!editable"
      class="vue-collapsable-handle"
      :class="{ 'glyphicon glyphicon-chevron-up': !collapsed, 'glyphicon glyphicon-chevron-down': collapsed }"
      style="color: #4d4d4d !important;"
      @click="collapsed ? cambiarCollapsed(false) : cambiarCollapsed(true)"
    ></div>
    <!-- //Iconos acciones -->
    <!-- Modo mostrar tabla -->
    <span
      v-if="!collapsed"
      style="padding-left: 25px !important;"
      :class="{ 'titulo-colapsado' : !editable, 'titulo-colapsado-editando' : editable }"
    >{{ config.nombre }}</span>
    <!-- Tabla -->
    <JqxLoader
      v-if="!editable && !collapsed"
      ref="jqxLoader"
      :imagePosition="'top'"
      :width="100"
      :height="60"
      :theme="'custom'"
      :text="'Cargando...'"
    ></JqxLoader>
    <JqxGrid
      v-if="!editable && !collapsed"
      class="mt-4"
      ref="tabla"
      :width="width"
      :height="heightTabla"
      :source="dataAdapter"
      :columns="columns"
      :filterable="filterable"
      :autoshowfiltericon="autoshowfiltericon"
      :sorting="sorting"
      :sortable="sortable"
      :groupable="groupable"
      :localization="localization"
      :showfilterrow="showfilterrow"
      :selectionmode="selectionmode"
      :scrollmode="scrollmode"
      :deferreddatafields="deferreddatafields"
      :altrows="altrows"
      :autosavestate="autosavestate"
      :autoshowloadelement="autoshowloadelement"
      :closeablegroups="closeablegroups"
      :showgroupaggregates="showgroupaggregates"
      :showstatusbar="showstatusbar"
      :showaggregates="showaggregates"
      :statusbarheight="statusbarheight"
      :columnsresize="columnsresize"
      :theme="theme"
      :enabletooltips="enabletooltips"
    ></JqxGrid>
    <!-- //Tabla -->
    <!-- //Modo mostrar tabla -->
    <!-- Modo colapsado -->
    <div
      v-if="collapsed"
      class="pl-4"
      :class="{'pointer' : !editable}"
      @click="!editable ? cambiarCollapsed(false) : null"
    >
      <span
        :class="{ 'titulo-colapsado' : !editable, 'titulo-colapsado-editando' : editable }"
      >{{ config.nombre }}</span>
    </div>
    <!-- //Modo colapsado -->
  </div>
</template>

<script>
import JqxGrid from "jqwidgets-scripts/jqwidgets-vue/vue_jqxgrid.vue";
import JqxLoader from "jqwidgets-scripts/jqwidgets-vue/vue_jqxloader.vue";
// Importamos las traducciones del jqxgrid
// TO-DO si se requieren más traducciones, crear los JSON correspondientes e importar la traduccion correspondiente a la variable lang
import traduccionJqxgrid from "@/lang/locale/es_ES_jqx.json";

export default {
  props: {
    editable: Boolean,
    config: Object,
    collapsed: Boolean,
    altura: Number,
    data: Array
  },
  components: {
    JqxGrid,
    JqxLoader
  },
  data() {
    return {
      bip_item_id: Number(this.$route.query.tienda),
      localization: Object,
      lang: this.$store.getters.lang,
      traduccionJqxgrid: traduccionJqxgrid,
      heightTabla: Number,
      // eslint-disable-next-line
      dataAdapter: new jqx.dataAdapter(this.source),
      width: "100%",
      columns: [],
      id: String,
      tableData: [],
      color: String,
      filterable: Boolean,
      autoshowfiltericon: Boolean,
      sorting: Boolean,
      sortable: Boolean,
      groupable: Boolean,
      showfilterrow: Boolean,
      selectionmode: String,
      scrollmode: String,
      deferreddatafields: String,
      altrows: Boolean,
      autosavestate: Boolean,
      autoshowloadelement: Boolean,
      closeablegroups: Boolean,
      showgroupaggregates: Boolean,
      showstatusbar: Boolean,
      showaggregates: Boolean,
      statusbarheight: Number,
      columnsresize: Boolean,
      theme: String,
      enabletooltips: Boolean
    };
  },
  beforeCreate: function() {
    this.source = {
      localdata: [],
      autoloadstate: true,
      datafields: [],
      datatype: "array"
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.setConfig();
  },
  mounted() {
    if (this.data !== undefined && this.data !== null)
      this.source.localdata = this.data;
    if (this.config !== undefined) {
      this.source.datafields = this.config.datafields;
      this.$nextTick(() => {
        if (this.$refs.tabla !== undefined) {
          this.$refs.tabla.updatebounddata();
          if (this.config.groups !== undefined) {
            this.config.groups.forEach(group => {
              this.$refs.tabla.addgroup(group);
            });
          }
        }
      });
    }
  },
  watch: {
    editable: {
      handler(n, o) {
        if (o === undefined || n !== o) {
          if (!n) {
            this.actualizarTablaTodo();
          }
        }
      },
      deep: true
    },
    data: {
      handler(n, o) {
        // if (o === undefined || n !== o) { // Si los datos que vienen esta vacios se vacia
          this.actualizarTablaDatos();
        // }
      },
      deep: true
    }
  },
  methods: {
    /**
     * Asigna los valores de configuracion definidos previamente en el tablas.json del id correspondiente
     */
    setConfig() {
      if (this.config !== undefined) {
        this.columns = this.config.columns;
        // Modificamos columns agregando las funciones de agregados
        this.config.columns.forEach(columna => {
          if (columna.agregados) {
            columna.aggregates = ['sum']; 
            columna.cellsrenderer = (row, column, value, defaultRender, rowData) => {
                            if (value.toString().indexOf('Sum') >= 0) {
                                return defaultRender.replace('Sum:', '');
                            }
            },
            columna.aggregatesrenderer = (aggregates) => {
                  var renderstring = '<div style="position: relative; margin-top: 4px; margin-right:5px; text-align: right; overflow: hidden;">' + 
                  ((aggregates.sum!==undefined) ? aggregates.sum : "0") + '</div>';
                  return renderstring;
            };
          }
        });
        this.showaggregates = this.config.showaggregates;
        this.id = this.config.idFila;
        this.heightTabla = this.config.heightTabla;
        this.color = this.config.color;
        this.filterable = this.config.filterable;
        this.autoshowfiltericon = this.config.autoshowfiltericon;
        this.sorting = this.config.sorting;
        this.sortable = this.config.sortable;
        this.groupable = this.config.groupable;
        this.showfilterrow = this.config.showfilterrow;
        this.selectionmode = this.config.selectionmode;
        this.scrollmode = this.config.scrollmode;
        this.deferreddatafields = this.config.deferreddatafields;
        this.altrows = this.config.altrows;
        this.autosavestate = this.config.autosavestate;
        this.autoshowloadelement = this.config.autoshowloadelement;
        this.closeablegroups = this.config.closeablegroups;
        this.showgroupaggregates = this.config.showgroupaggregates;
        this.showstatusbar = this.config.showstatusbar;
        this.showaggregates = this.config.showaggregates;
        this.statusbarheight = this.config.statusbarheight;
        this.columnsresize = this.config.columnsresize;
        this.theme = this.config.theme;
        this.enabletooltips = this.config.enabletooltips;
        this.localization = this.getLocalization();
      }
    },
    actualizarTablaTodo() {
      if (this.data !== undefined && this.data !== null)
        this.source.localdata = this.data;

      // Anhadimos la agrupacion inicial de la tabla (si la hubiere)
      this.$nextTick(() => {
        if (
          this.$refs.tabla !== undefined &&
          this.config !== undefined &&
          this.config.groups !== undefined
        ) {
          this.config.groups.forEach(group => {
            this.$refs.tabla.addgroup(group);
          });
        }
      });
    },
    actualizarTablaDatos() {
      while (this.source.localdata.length > 0) {
        this.source.localdata.pop();
      }
      if (this.data !== undefined && this.data !== null) {
        this.source.localdata = this.data;
      }
      this.$nextTick(() => {
        if (this.$refs.tabla !== undefined) {
          this.$refs.tabla.updatebounddata();
          if (this.config.groups !== undefined) {
            this.config.groups.forEach(group => {
              this.$refs.tabla.addgroup(group);
            });
          }
        }
      });
    },
    onClickEliminar() {
      if (this.config.id !== undefined && this.config.id != null) {
        this.$emit("eliminartabla", this.config.id);
      }
    },
    /**
     * TO-DO crear diferentes traducciones (solo hay castellano) y asignar la correspondiente dependiendo de la variable lang
     */
    getLocalization() {
      let traduccion = this.traduccionJqxgrid;
      return traduccion;
    },
    cambiarCollapsed(value) {
      let collapseOptions = {};
      collapseOptions.collapse = value;
      collapseOptions.id = this.config.id;
      collapseOptions.tipo = this.config.tipo;
      collapseOptions.altura = this.altura;
      this.$emit("collapseTabla", collapseOptions);

      // Anhadimos los agrupamientos cuando se descolapse
      if (!value) {
        this.$nextTick(() => {
          if (this.config.groups !== undefined) {
            this.config.groups.forEach(group => {
              this.$refs.tabla.addgroup(group);
            });
          }
        });
      }
    },
    /**
     * Ajusta el ancho del jqxgrid dependiendo del ancho del parent
     */
    handleResize() {
      if (
        this.$refs.tablaParent !== undefined &&
        this.$refs.tablaParent.clientWidth !== undefined
      ) {
        this.width = this.$refs.tablaParent.clientWidth - 20;
      }
    }
  }
};
</script>